import { render, staticRenderFns } from "./newsPage07.vue?vue&type=template&id=63b76d79&scoped=true&"
import script from "./newsPage07.vue?vue&type=script&lang=js&"
export * from "./newsPage07.vue?vue&type=script&lang=js&"
import style0 from "./newsPage07.vue?vue&type=style&index=0&id=63b76d79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b76d79",
  null
  
)

export default component.exports